// extracted by mini-css-extract-plugin
export var brand = "KeepSubscriptions_brand__WPLLP";
export var buttonsContainer = "KeepSubscriptions_buttonsContainer__k6RzE";
export var disclaimerContainer = "KeepSubscriptions_disclaimerContainer__Tl63f";
export var disclaimerNote = "KeepSubscriptions_disclaimerNote__7gco4";
export var imageWrapper = "KeepSubscriptions_imageWrapper__SyuIp";
export var isSelected = "KeepSubscriptions_isSelected__JF2ti";
export var keepSubscriptionsContainer = "KeepSubscriptions_keepSubscriptionsContainer__2lLXV";
export var mainButtonContainer = "KeepSubscriptions_mainButtonContainer__bPDNb";
export var productCard = "KeepSubscriptions_productCard__k3tof";
export var productSkeleton = "KeepSubscriptions_productSkeleton__s1xH9";
export var productsContainer = "KeepSubscriptions_productsContainer__nxvsR";
export var textButton = "KeepSubscriptions_textButton__rchwj";
export var title = "KeepSubscriptions_title__x3mvU";